import { environmentHttpClient } from "client/Api/httpClient";
import { ResultMapperColor } from "client/Api/IntegrationBuilder/integrationBuilderFlows";
import { IntegrationFlowMultipleAuthenticationsAreRequiredModel } from "client/Api/IntegrationBuilder/integrationBuilderAuthentication";

export type ColoredValueModel<TValue> = {
	value: TValue;
	color: ResultMapperColor | null;
};

export type AppIntegrationFlowResultItemModel = {
	title: ColoredValueModel<string> | null;
	dateTime: ColoredValueModel<string> | null;
	subtitle1: ColoredValueModel<string> | null;
	subtitle2: ColoredValueModel<string> | null;
	subtitle3: ColoredValueModel<string> | null;
	description: ColoredValueModel<string> | null;
	link: string | null;
};

export enum AppIntegrationLiveInformationResultStatus {
	Success = 1,
	AuthenticationIsRequired = 2,
	Failure = 3
}

export type AppIntegrationFlowResultBase = {
	integrationId: number;
};

export type AppIntegrationFlowResult = AppIntegrationFlowResultBase & ({
	status: AppIntegrationLiveInformationResultStatus.Failure;
} | {
	status: AppIntegrationLiveInformationResultStatus.AuthenticationIsRequired;
	authenticationModel: IntegrationFlowMultipleAuthenticationsAreRequiredModel;
} | {
	status: AppIntegrationLiveInformationResultStatus.Success;
	items: readonly AppIntegrationFlowResultItemModel[];
});

export type LiveInformationRequestModel = {
	integrationId: number;
};

export function getLiveInformation(
	model: readonly LiveInformationRequestModel[]
): Promise<readonly AppIntegrationFlowResult[]> {
	return environmentHttpClient.post<readonly AppIntegrationFlowResult[]>(
		"Workspace/LiveInformation/AppIntegration",
		model
	);
}
